import { Component, OnInit } from '@angular/core';
import { QueryParam } from '../query-param';
import { ApiService } from '../services/api.service';

@Component({
  selector: 'app-new-faq',
  templateUrl: './new-faq.component.html',
  styleUrls: ['./new-faq.component.css']
})
export class NewFaqComponent implements OnInit {

  constructor(    private apiService: ApiService) { }

  queryParam!: QueryParam;


  ngOnInit(): void {

    let storageName = this.apiService.getItem();
    this.queryParam = JSON.parse(
      localStorage.getItem(storageName) || 'undefined'
    );
  }

}
